import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useMemo, useState } from 'react';
import { scrollTo } from 'datastake-daf/src/helpers/GoToSelect';
import { CustomIcon, GoToSelect } from 'datastake-daf/dist/components';
import Style from '../style';
import { selectOptions } from './config';
import SCLMap from '../../scl-widgets/map';
import RiskHistory from '../../scl-widgets/risk-history';
import RiskCategories from '../../scl-widgets/risk-categories';
import RiskMitigation from '../../scl-widgets/risk-mitigation';
import AssociatedEvents from '../../scl-widgets/associated-events';
import StakeholderMapping from '../../scl-widgets/stakeholder-mapping';
import CorrectiveMeasures from '../../scl-widgets/corrective-measures';
import RiskMaterialisation from '../../scl-widgets/risk-materialisation';

export default function SCLLayout({
  namespace = null,
  data = null,
  sources = {},
  activeSources = [],
  isOwnData = false,
  setVisibleSettings = () => { },
  other = {},
  isSingleSource = false,
  redirectToView = () => { },
  selectedSource = null,
  getOption = () => { },
  hasDDSystems = false,
  sidebarCollapsed,
  options = {},
  loading = false,
  language = 'en',
  locationId = '',
  mod = '',
  mode,
}) {
  const { t } = useTranslation()
  const [value, setValue] = useState(undefined);
  const [filterKey, setFilterKey] = useState(null);

  const _onChange = (val) => {
    const _cont = document.querySelector('.view-content');
    setValue(val);

    if (_cont) {
      const diff = isSingleSource ? 275 : 220;

      switch (val) {
        case '1d':
        case '2d':
          const _el1 = document.getElementById('1d');
          scrollTo({ _el: _el1, _cont, diff });
          break;
        case '3d':
        case '4d':
        case '5d':
          const _el2 = document.getElementById('3d');
          scrollTo({ _el: _el2, _cont, diff });
          break;
        case '6d':
        case '7d':
          const _el3 = document.getElementById('6d');
          scrollTo({ _el: _el3, _cont, diff });
          break;
        case '8d':
          const _el4 = document.getElementById('8d');
          scrollTo({ _el: _el4, _cont, diff });
          break;
        case '9d':
          const _el5 = document.getElementById('9d');
          scrollTo({ _el: _el5, _cont, diff });
          break;
        default:
      }

      setFilterKey(val);
    }
  };

  useEffect(() => {
    if (filterKey) {
      setFilterKey(null);
    }
  }, [filterKey]);

  const allSources = useMemo(() => {
    const all = [];
    if (sources) {
      Object.values(sources).forEach((v) => {
        all.push(...v);
      })
    }
    return all;
  }, [sources])

  const analysisSourceId = useMemo(() =>
    selectedSource ? selectedSource === 'overview' ? undefined : selectedSource : activeSources
    , [selectedSource, activeSources]);

  const subjectId = useMemo(() => data.subjectId, [data.subjectId]);

  return (
    <Style
      className={
        `no-padding ${mode === 'app' ? !isOwnData ? (sidebarCollapsed ? 'not-collapsed' : 'collapsed') : (sidebarCollapsed ? 'own-data-not-collapsed' : 'own-data-collapsed') : ''}`
      }
    >
      <div className="go-select-cont">
        <GoToSelect
          mainClassName=".view-content"
          className="full mb-0"
          onChange={_onChange}
          options={selectOptions}
          setValue={setValue}
          value={value}
        >
          {!(isOwnData || isSingleSource) ? (
            <Button
              icon={(
                <CustomIcon name="Filters" width={16} height={16} />
              )}
              onClick={() => setVisibleSettings(true)}
            >
              {t('Data Settings')}
            </Button>
          ) : null}
        </GoToSelect>
      </div>

      <div className="sections-cont">
        {data && namespace ? (
          <>
            <SCLMap
              data={data.map || { scl: {}, village: null, town: null }}
              isSingleSource={isSingleSource}
              locationId={locationId}
              isOwnData={isOwnData}
              loading={loading}
              mod={mod}
              mode={mode}
              allSources={allSources}
              filterKey={filterKey}
            />
            <div className="sections">
              <section className="overflow-section no-wrap" id="3d">
                <RiskHistory data={data.riskHistory || { data: {} }} loading={loading} />
                <RiskCategories data={data.riskCategories || {}} loading={loading} />
                <AssociatedEvents
                  data={data.events}
                  isSingleSource={isSingleSource}
                  loading={loading}
                  isOwnData={isOwnData}
                  options={options.riskSubcategoriesOptions || []}
                  riskCategories={options.riskCategories || []}
                  language={language}
                  sourceId={analysisSourceId}
                  subjectId={subjectId}
                />
              </section>
              <section className="overflow-section no-wrap" id="6d">
                <RiskMaterialisation
                  data={data.riskMaterialisation}
                  loading={loading}
                  isOwnData={isOwnData}
                />
                <RiskMitigation
                  data={data.riskMitigation}
                  isSingleSource={isSingleSource}
                  options={options.riskSubcategoriesOptions || []}
                  isOwnData={isOwnData}
                  loading={loading}
                  riskCategories={options.riskCategories || []}
                />
              </section>
              <section className="overflow-section" id="8d">
                <CorrectiveMeasures
                  mode={mode}
                  loading={loading}
                  mod={mod}
                  sourceId={selectedSource}
                  isOwnData={isOwnData}
                  sidebarCollapsed={sidebarCollapsed}
                  data={data.measures}
                  locationId={locationId}
                />
              </section>
              <section id="9d">
                <StakeholderMapping
                  mod={mod}
                  mode={mode}
                  data={data.stakeholdersMapping}
                  isSingleSource={isSingleSource}
                  sources={sources}
                  loading={loading}
                />
              </section>
            </div>
          </>
        ) : null}
      </div>
    </Style>
  );
}
